import { EventTypeEditItem, IEventTypeEditItem } from "./eventTypeEditItem";

export interface IEventTypeEdit {
    eventType: IEventTypeEditItem;
}

export class EventTypeEdit implements IEventTypeEdit {
    eventType: EventTypeEditItem;

    constructor();
    constructor(obj: IEventTypeEdit);
    constructor(obj?: any) {
        this.eventType = new EventTypeEditItem(obj ? obj.eventType : null);
    }
}